export default [
    {
    path: '/register/emailRegisterTwo',
    name: 'emailRegisterTwo',
    meta: {
      index: 3
    },
    component: () => import('@/views/register/emailRegisterTwo')
  }
  ]
  